<template>
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true" :isCustomReturnEvent="true" @returnEvent="handleClickReturnRouter"></ReturnNavBar>
        </div>
        <div class="work_order_add_container mobile_container" v-loading="loading">
            <CustomFormMobile
                ref="workOrderForm"
                :field_list="formInfoList"
                :pk_id="Number(work_order_id)"
                :is_form_module="true"
                :form_detail="workOrderFormData"
                @submit-form="submitFormData"
                v-if="dataLoaded"
            />

            <div class="add_approval_select_process" v-if="isApproval === 1">
                <approveProcessSelect
                    ref="approveProcessSelectRef"
                    :approval_node_list="approval_node_list"
                ></approveProcessSelect>
            </div>
        </div>
        <div class="add_footer_wrap mobile_add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">确定</van-button>
        </div>
    </div>
</template>

<script>
import { getApprovalNodes, getFormFields, workOrderAdd, workOrderSetDetail, workOrderDetail } from "@/api";
import {EventBus} from '@/utils/eventBus';
import {removeTag} from "@/utils";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
import approveProcessSelect from "@/components/mComponents/approveProcessSelect";
export default {
    name: "WorkOrderAddAgain",
    components: { ReturnNavBar, CustomFormMobile, approveProcessSelect },
    data() {
        return {
            work_order_id: this.$route.query.work_order_id,
            loading: false,
            isApproval: 0,
            mode: 0,
            formInfoList: [],
            workOrderFormData: {},
            dataLoaded: false,
            btnDisabled: false,
            approval_node_list: [],
        };
    },
    created() {
        this.getWorkOrderDetail();
    },
    methods: {
        handleClickReturnRouter() {
            removeTag(this.$route)
            this.$router.go(-1);
        },
        // 获取当前的工单数据
        getWorkOrderDetail() {
            this.loading = true;
            this.dataLoaded = false;
            workOrderDetail({
                id: this.work_order_id,
            }).then((res) => {
                if (res.code === 200) {
                    const { workorder, custom_fields } = res.data;
                    this.workOrderFormData = workorder;
                    this.formInfoList = custom_fields;
                    workOrderSetDetail().then((res) => {
                        this.isApproval = res.data.is_create_approve;
                        if (this.isApproval === 1) {
                            // 回显审批流程数据
                            // this.approval_node_list = workorder.node_list || [];
                            // this.$refs.approveProcessSelectRef.set_approval_node_list(res.data);

                            getApprovalNodes({
                                approval_type: "workorder_create",
                            })
                                .then((res) => {
                                    if (res.code === 200) {
                                        this.approval_node_list = res.data;
                                        this.$refs.approveProcessSelectRef.set_approval_node_list(res.data);
                                    } else {
                                        this.$message.error(res.message);
                                    }
                                    this.loading = false;
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        }
                    });
                    this.dataLoaded = true;
                    this.loading = false;
                } else [(this.loading = false)];
            });
        },
        handleClickConfirm() {
            this.$refs.workOrderForm.handleClickPublish();
        },
        submitFormData(customForm) {
            if (customForm) {
                let params = {
                    ...customForm,
                    node_list: this.approval_node_list,
                    mode: this.workOrderFormData.mode,
                };
                const workorder_role_data = this.formInfoList.filter(field=> field.field_type === 'workorder_role')
                workorder_role_data.forEach(field=> {
                    if(field.extend.relate_role_type === 'assign_user') {
                        params.assign_uids = data[field.field_key]?.value || []
                    } else if(field.extend.relate_role_type === 'processing_user') {
                        params.processing_uids = data[field.field_key]?.value || []
                    }
                })
                this.BtnDisabled = true;
                workOrderAdd(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    removeTag(this.$route);
                                    EventBus.$emit('workOrderAddUpdated');
                                    this.$router.go(-1);
                                    this.BtnDisabled = false;
                                },
                            });
                        } else {
                            this.BtnDisabled = false;
                        }
                    })
                    .catch(() => {
                        this.BtnDisabled = false;
                    });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.custom_form_wrap {
    height: auto;
}
.work_order_add_container {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
}
.add_approval_select_process {
    padding: 10px 16px;
    background: #fff;
}
</style>
